export const queryKey = {
  myInfo: ['myInfo'],
  getInfiniteLikeFolders: ['getInfiniteLikeFolders'],
  getInfiniteRecentlyViewedGoods: ['getInfiniteRecentlyViewedGoods'],
  getMemberInfoQuery: ['getMemberInfoQuery'],
  cartMeta: ['cartMeta'],
  proxy: (url?: string) => ['proxy', url],
} as const;
